module.exports = __webpack_public_path__ + "static/media/popup-alert.057d4fe4.svg";